import { WorkItemField } from 'azure-devops-extension-api/WorkItemTracking';

export function findAllFieldTypesByWorkItemField(workItemTypeList: Array<WorkItemField>): Array<WorkItemField> {
	const results: Array<WorkItemField> = [];

	for (let i = 0; i < workItemTypeList.length; i++) {
		const item = workItemTypeList[i];
		const idxItem = results.findIndex(fItem => item.referenceName === fItem.referenceName);

		if (idxItem === -1) {
			results.push(item);
		}
	}

	return results;
}